import { formatearPlazo } from "./format";

// Build 1 · Factoraje financiero (solo SOFOM). Espejo en pantalla de `backend/factoraje.py`:
// el anticipo y los autocompletados los fija SIEMPRE el backend.
export const TIPO_FACTORAJE = "Factoraje financiero";
export const GARANTIA_FACTORAJE = "Derechos de crédito cedidos";
export const FUENTE_PAGO_FACTORAJE = "Ventas a terceros";

export const esFactoraje = (producto) => String(producto?.tipo || "").trim() === TIPO_FACTORAJE;

export const calcularAnticipo = (valor, aforo) => {
  const v = Number(valor), a = Number(aforo);
  if (!Number.isFinite(v) || !Number.isFinite(a) || v <= 0 || a <= 0) return null;
  return Math.round(v * a) / 100;
};

// Campos del producto que no aplican a factoraje, y los propios del factoraje.
export const CAMPOS_PRODUCTO_NO_FACTORAJE = [
  "periodicidad", "plazos_permitidos", "primer_pago_ancla", "tipo_amortizacion", "redondeo_total_fijo",
];
export const CAMPOS_PRODUCTO_FACTORAJE = [
  "aforo_pct", "plazo_max_dias_factura", "limite_por_deudor", "base_dias_descuento",
];

const isoDia = (d) => d.toISOString().slice(0, 10);
export const rangoVencimiento = (plazoMaxDias) => {
  const hoy = new Date();
  const min = new Date(hoy); min.setDate(hoy.getDate() + 1);
  const max = new Date(hoy); max.setDate(hoy.getDate() + Number(plazoMaxDias || 0));
  return { min: isoDia(min), max: plazoMaxDias ? isoDia(max) : undefined };
};

// Build 2 · Crédito de factoraje: tabla de UNA sola cuota (pago único al vencimiento).
export const PERIODICIDAD_FACTORAJE = "Pago único al vencimiento";
export const esCreditoFactoraje = (c) =>
  c?.tipo_amortizacion === "pago_unico_vencimiento" || c?.amort_input?.motor === "factoraje";
export const periodicidadCredito = (c) => (esCreditoFactoraje(c) ? PERIODICIDAD_FACTORAJE : c?.periodicidad);
// Build 3 · Pagador del pago de factoraje, estatus con remanente y medios de devolución.
export const PAGADORES_FACTORAJE = [
  { value: "deudor", label: (c) => `Deudor registrado: ${c?.factoraje?.deudor_nombre || "—"}` },
  { value: "cliente", label: () => "Cliente" },
  { value: "tercero", label: () => "Otro tercero" },
];
export const estatusCredito = (c) => c?.estatus_operacion || c?.estatus;
export const MEDIOS_DEVOLUCION = [
  { value: "spei", label: "SPEI" },
  { value: "transferencia", label: "Transferencia" },
  { value: "cheque", label: "Cheque" },
];
export const hoyMX = () => new Intl.DateTimeFormat("en-CA",
  { timeZone: "America/Mexico_City", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());

export const plazoCredito = (c) => {
  if (!esCreditoFactoraje(c)) return formatearPlazo(c?.plazo, c?.periodicidad);
  const d = c?.factoraje?.dias_descuento ?? c?.tabla_amortizacion?.[0]?.dias_descuento;
  return d ? `${PERIODICIDAD_FACTORAJE} · ${d} días` : PERIODICIDAD_FACTORAJE;
};
